<!--继承上传图片组件-->
<script>
import qs from 'qs'
import uploadImgEle from '@/components/upload/uploadImgEle'
import { ocrCheck } from '@/api/global'
export default {
  name: 'OCRRecognition',
  extends: uploadImgEle,
  props: {
    type: {
      type: String,
      default: '10' // 10营业执照，8身份证人像面，7身份证国徽面，9银行卡
    },
    toCheck: {
      type: Boolean,
      default: true // 是否识别
    }
  },
  data () {
    return {
      path: ''
    }
  },
  watch: {
    value (val, oldVal) {
      if (this.result === '') {
        // 路径中没有http说明不是只读的，
        // 父组件的方法先执行上传，子组件的方法再识别图片
        if (this.value && this.value.indexOf('http://') < 0) {
          this.path = val
          if (this.toCheck && this.path !== '') this.OCRSubmit()
        }
      }
      // 说明是被清空，将result也置位空
      if (val === '') {
        this.result = ''
        this.resultShow = ''
      }
    }
  },
  mounted () {
    if (this.value && this.result === '') {
      // 路径中没有http说明不是只读的，
      // 父组件的方法先执行上传，子组件的方法再识别图片
      if (this.value.indexOf('http://') < 0) {
        this.path = this.value
        if (this.toCheck && this.path !== '') {
          this.OCRSubmit()
        }
      }
    }
  },
  methods: {
    // 复写图片上传成功后传递给父级的方法
    emitResult (result) {
      this.path = result.path
      if (this.toCheck && this.path !== '') {
        this.OCRSubmit()
      } else {
        this.$emit('submit', {
          valueName: this.valueName,
          path: this.path,
          success: false
        })
      }
    },
    OCRSubmit () {
      const that = this
      const params = qs.stringify({
        picType: this.type,
        picUrl: this.path
      })
      this.loading = true
      ocrCheck(params).then(response => {
        this.loading = false
        let result = false // 是否识别成功
        if (parseInt(response.result_cde) === 0 && JSON.stringify(response.data) !== '{}') {
          // 请求OCR识别接口，使用参数type
          result = true
        } else {
          result = false
        }
        setTimeout(function () {
          // 判断是否识别成功
          if (!result) {
            that.$message({
              message: 'OCR识别失败，请检查照片上传是否正确且清晰',
              type: 'warning'
            })
            that.$emit('submit', {
              valueName: that.valueName,
              path: that.path,
              success: false
            })
          } else {
            const data = Object.assign({}, response.data, {
              valueName: that.valueName,
              path: that.path,
              success: true
            })
            that.$message({
              message: 'OCR识别成功，请核对信息是否正确，若有误可自行修改',
              type: 'success'
            })
            that.$emit('submit', data)
          }
        }, 1000)
      })
    }
  }
}
</script>
